(function () {
  "use strict";
  function addStyles() {
    if (document.getElementById("genkidama-card-ratings-style")) return;
    var style = document.createElement("style");
    style.id = "genkidama-card-ratings-style";
    style.textContent = [
      ".genkidama-card-rating{display:flex;align-items:center;justify-content:center;gap:6px;min-height:22px;margin-top:8px;color:#ff9f00;font-size:1.32rem;font-weight:950;line-height:1;letter-spacing:.06em}",
      ".genkidama-card-rating small{color:#5f5550;font-size:.9rem;font-weight:850;letter-spacing:0}",
      ".genkidama-card-rating.is-empty{color:#e4d6ca}"
    ].join("");
    document.head.appendChild(style);
  }

  function stars(value) {
    var rating = Math.max(0, Math.min(5, Math.round(Number(value || 0))));
    return "★★★★★".slice(0, rating) + "☆☆☆☆☆".slice(0, 5 - rating);
  }

  function setEmpty(node) {
    node.classList.add("is-empty");
    node.innerHTML = '<span aria-hidden="true">☆☆☆☆☆</span>';
    node.setAttribute("aria-label", "Noch keine Bewertung");
  }

  function setRating(node, comments) {
    var ratings = (comments || []).map(function (comment) {
      return Number(comment.rating || 0);
    }).filter(function (rating) {
      return rating >= 1 && rating <= 5;
    });
    if (!ratings.length) {
      setEmpty(node);
      return;
    }
    var sum = ratings.reduce(function (total, rating) {
      return total + rating;
    }, 0);
    var avg = sum / ratings.length;
    node.classList.remove("is-empty");
    node.innerHTML = [
      '<span aria-hidden="true">' + stars(avg) + '</span>',
      '<small>' + avg.toFixed(1).replace(".", ",") + ' (' + ratings.length + ')</small>'
    ].join("");
    node.setAttribute("aria-label", avg.toFixed(1) + " von 5 Sternen bei " + ratings.length + " Bewertung(en)");
  }

  async function loadOne(node) {
    if (node.dataset.genkidamaRatingLoaded === "1") return;
    node.dataset.genkidamaRatingLoaded = "1";
    var productId = node.dataset.productId || "";
    var productHandle = node.dataset.productHandle || "";
    if (!productId && !productHandle) {
      setEmpty(node);
      return;
    }
    try {
      var url = "/apps/genkidama/comments?product_id=" + encodeURIComponent(productId) +
        "&product_handle=" + encodeURIComponent(productHandle);
      var response = await fetch(url, { credentials: "same-origin" });
      var data = await response.json();
      if (!data.ok) throw new Error(data.error || "Fehler");
      setRating(node, data.comments || []);
    } catch (err) {
      setEmpty(node);
    }
  }

  function loadAll(root) {
    addStyles();
    (root || document).querySelectorAll("[data-genkidama-card-rating]").forEach(loadOne);
  }

  window.GenkidamaCardRatings = { load: loadAll };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { loadAll(document); });
  } else {
    loadAll(document);
  }
})();
